<div class="component-container" *ngIf="showPhotovoltaicsDataSection()">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div class="margin-header-align section-heading text-uppercase">
      <div class="ui-g-12">
        <app-section-header
          [title]="'grid-comp.photovoltaic-title' | translate"
          [tooltip]="'tooltips.technical-data.photovoltaic' | translate"></app-section-header>
      </div>
      <div class="section-buttons">
        <lock-unlock-buttons
          [showLockButton]="isDetailsView"
          [showUnlockButton]="isDetailsView"
          [isLocked]="getSectionLocked()"
          [areButtonsDisabled]="!(isModeratorRole() && editabilityBasedOnProcessStatus.internalRoles)"
          (lockButtonClickedEvent)="lockSection()"
          (unLockButtonClickedEvent)="unlockSection()"></lock-unlock-buttons>
        <i
          *ngIf="isDetailsView"
          class="pi pi-comment"
          [ngClass]="isCommentVisible || getSectionComment() ? 'lock-icon-style' : 'unlock-icon-style'"
          [pTooltip]="showCommentTooltip() ? ('comment-section.comment-tooltip' | translate) : null"
          [tooltipPosition]="showCommentTooltip() ? 'bottom' : null"
          (click)="showComment()"></i>
      </div>
    </div>
  </div>
  <section-comment
    [isCommentTextInputVisible]="isModeratorRole() && (isCommentVisible || getSectionComment())"
    [isCommentTextVisible]="!isModeratorRole()"
    [isCommentSaveVisible]="!getSectionComment()"
    [isCommentDeleteButtonDisabled]="!editabilityBasedOnProcessStatus.internalRoles"
    [comment]="getSectionComment()"
    (saveCommentEvent)="updateComment($event)"
    (deleteCommentEvent)="deleteComment()"
    (changeTextEvent)="changeCommentText.emit($event)"></section-comment>
  <div [ngClass]="getSectionLocked() !== true || !applicationId ? '' : 'disable-section'">
    <div class="section-wrapper margin-align">
      <div class="section-field">
        <label class="ui-g-5 required">
          {{ 'grid-comp.pv-modules-total-power' | translate }}
        </label>
        <p-inputNumber
          class="form-control"
          [(ngModel)]="technicalData.total_power_pv_modules"
          (ngModelChange)="calculatePhotovoltaicsPowerDifference(true)"
          name="totalPowerPvModules"
          #totalPowerPvModules="ngModel"
          mode="decimal"
          locale="de-DE"
          [minFractionDigits]="0"
          (keydown)="detectDecimalSeparator($event)"
          [maxFractionDigits]="3"
          required
          [disabled]="isSectionDisabled"></p-inputNumber>
        <label class="ml-2">kWp</label>
      </div>
      <div *ngIf="pvModulesPowerNotEqual" class="section-field">
        <i class="pi pi-exclamation-circle"></i>
        <span>{{ 'grid-comp.pv-modules-power-warning' | translate }}</span>
      </div>
      <div
        *ngFor="let photovoltaic of technicalData.photovoltaic_modules; index as i"
        class="pv-module-container top-bottom-margin bottom-border section-column">
        <div class="section-field">
          <label class="ui-g-2 font-bold zero-padding">
            {{ 'grid-comp.pv-modules-data' | translate }}
            {{ i + 1 }}
          </label>
        </div>
        <div class="section-field">
          <label class="ui-g-5 required">
            {{ 'grid-comp.manufacturer' | translate }}
          </label>
          <input
            class="form-control"
            type="text"
            pInputText
            [(ngModel)]="photovoltaic.manufacturer"
            name="photoManufacturer{{ i }}"
            #photoManufacturer{{i}}="ngModel"
            required
            [disabled]="isSectionDisabled" />
        </div>
        <div class="section-field">
          <label class="ui-g-5 required">
            {{ 'grid-comp.number-identical-modules' | translate }}
          </label>
          <p-inputNumber
            class="form-control"
            [(ngModel)]="photovoltaic.identical_modules"
            (ngModelChange)="calculatePhotovoltaicsPowerDifference()"
            name="photoIdenticalModules{{ i }}"
            #photoIdenticalModules{{i}}="ngModel"
            required
            [disabled]="isSectionDisabled"></p-inputNumber>
        </div>
        <div class="section-field">
          <label class="ui-g-5 required">
            {{ 'grid-comp.type' | translate }}
          </label>
          <input
            class="form-control"
            type="text"
            pInputText
            [(ngModel)]="photovoltaic.type"
            name="photoType{{ i }}"
            #photoType{{i}}="ngModel"
            required
            [disabled]="isSectionDisabled" />
        </div>
        <div class="section-field">
          <label class="ui-g-5 required">
            {{ 'grid-comp.one-module-power' | translate }}
          </label>
          <p-inputNumber
            class="form-control"
            [(ngModel)]="photovoltaic.power_single_pv_module"
            (ngModelChange)="calculatePhotovoltaicsPowerDifference()"
            name="photoPowerSinglePVModule{{ i }}"
            #photoPowerSinglePVModule{{i}}="ngModel"
            (keydown)="detectDecimalSeparator($event)"
            mode="decimal"
            locale="de-DE"
            [minFractionDigits]="0"
            [maxFractionDigits]="3"
            required
            [disabled]="isSectionDisabled"></p-inputNumber>
          <label class="ml-2">Wp</label>
        </div>
        <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 mb-3 field-padding section-field">
          <label class="ui-g-5 required">
            {{ 'grid-comp.module-data-sheet' | translate }}
          </label>
          <app-file-upload
            class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6"
            [fileData]="photovoltaic.data_sheet"
            [type]="documentTypes.PhotovoltaicDataSheet"
            [isDetailsView]="isDetailsView && photovoltaic.data_sheet?.document_id"
            [isClearButtonDisabled]="isSectionDisabled"
            [inputName]="'product_data_sheet' + i"
            [isRequired]="!isModeratorRole()"
            (clearFileEvent)="clearFile($event)"></app-file-upload>
        </div>
        <div *ngIf="showFotoProofPhotovoltaicModules">
          <div *ngFor="let document of photovoltaic.foto_proof_photovoltaic_modules; let ph = index; trackBy: trackBy">
            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 mb-3 field-padding section-field">
              <label class="ui-g-5">
                {{ 'grid-comp.foto-proof-photovoltaic-modules' | translate }}
              </label>
              <app-file-upload
                class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-6"
                [fileData]="document"
                [inputName]="'foto_proof_photovoltaic_modules' + i + ph"
                [isDetailsView]="isDetailsView && document?.document_id"
                [isClearButtonDisabled]="isSectionDisabled"
                [type]="documentTypes.FotoProofPhotovoltaicModules"
                [isRequired]="false"
                (clearFileEvent)="clearFile($event)"></app-file-upload>
              <div *ngIf="ph > 0" class="section-field file-name-section" [ngClass]="isSectionDisabled ? 'disable-section' : ''">
                <i (click)="removeDocument(i, ph)" class="pi pi-trash pointer-cursor delete-icon"></i>
              </div>
            </div>
          </div>

          <div class="section-field" [ngClass]="isSectionDisabled ? 'disable-section' : ''">
            <i
              (click)="addDocument(i)"
              class="pi pi-plus plus-icon new-facility-plus-icon"
              id="add-foto-proof"
              tabindex="0"
              appEnterClick></i>
            <label class="field-label" for="add-foto-proof">
              {{ 'grid-comp.add-foto-proof-photovoltaic-modules' | translate }}
            </label>
          </div>
        </div>
        <div
          *ngIf="i > 0"
          (click)="removePvModule(photovoltaic)"
          class="pi pi-trash pointer-cursor right-aligned ui-g-12"
          [ngClass]="isSectionDisabled ? 'disable-section' : ''"></div>
        <div
          *ngIf="i === technicalData.photovoltaic_modules.length - 1"
          class="section-field"
          [ngClass]="isSectionDisabled ? 'disable-section' : ''">
          <i (click)="addPvModule()" class="pi pi-plus plus-icon margin-zero" tabindex="0" appEnterClick></i>
          <label class="field-label">
            {{ 'grid-comp.add-module' | translate }}
          </label>
        </div>
      </div>
      <div class="section-field">
        <label class="ui-g-5">
          {{ 'grid-comp.inverters-total-power' | translate }}
        </label>
        <p-inputNumber
          class="form-control"
          [(ngModel)]="technicalData.total_power_inverters"
          (ngModelChange)="calculateInvertersPowerDifference()"
          name="total_power_inverters"
          (keydown)="detectDecimalSeparator($event)"
          #total_power_inverters="ngModel"
          mode="decimal"
          locale="de-DE"
          [minFractionDigits]="0"
          [maxFractionDigits]="3"
          required
          [disabled]="isSectionDisabled"></p-inputNumber>
        <label class="ml-2">kW</label>
      </div>
      <div *ngIf="invertersPowerNotEqual" class="section-field">
        <i class="pi pi-exclamation-circle"></i>
        <span>{{ 'grid-comp.inverters-power-warning' | translate }}</span>
      </div>
      <div class="bottom-border">
        <div *ngFor="let powerInverter of technicalData.power_inverters; index as i" class="top-bottom-margin">
          <app-eproducer-unit-form-element
            [energyUnit]="powerInverter"
            [index]="i"
            [isDetailsView]="isDetailsView"
            [isDisabled]="isSectionDisabled"
            [documents]="powerInverter.documents"
            [type]="UI_COLLECTION_TYPES.PowerInverter"
            (removeElementEvent)="removePowerInverter($event)"
            (maxPowerChangeEvent)="calculateInvertersPowerDifference()"
            (clearFileEvent)="clearFile($event)"
            (calculateInvertersPowerDifference)="calculateInvertersPowerDifference()"></app-eproducer-unit-form-element>
        </div>

        <div class="section-field" [ngClass]="isSectionDisabled ? 'disable-section' : ''">
          <i (click)="addPowerInverter()" class="pi pi-plus plus-icon margin-zero" tabindex="0" appEnterClick></i>
          <label class="field-label">
            {{ 'grid-comp.add-inverter' | translate }}
          </label>
        </div>
      </div>
    </div>
  </div>
</div>
